import { Directive, ViewContainerRef } from "@angular/core";

@Directive({
    selector: "[appDynamicReport]",
    standalone: false
})
export class DynamicReportDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
